import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, deleteToken } from 'firebase/messaging';

console.log('[Firebase] ===== INITIALIZING FIREBASE =====');

const firebaseConfig = {
  apiKey: "AIzaSyBnp8zBzYsmEjj6tDI7ttLH_1kwIHxb3Bw",
  projectId: "reliance-digital-firebase",
  storageBucket: "reliance-digital-firebase.firebasestorage.app",
  messagingSenderId: "183729008613",
  appId: "1:183729008613:android:ebcfb3619c56472bf0c90c",
  databaseURL: "https://reliance-digital-firebase-default-rtdb.firebaseio.com"
};

console.log('[Firebase] Firebase Config:', {
  projectId: firebaseConfig.projectId,
  messagingSenderId: firebaseConfig.messagingSenderId,
  appId: firebaseConfig.appId
});

console.log('[Firebase] Initializing Firebase app...');
const app = initializeApp(firebaseConfig);
console.log('[Firebase] ✅ Firebase app initialized');

console.log('[Firebase] Getting messaging instance...');
const messaging = getMessaging(app);
console.log('[Firebase] ✅ Messaging instance created');

export { messaging, getToken, onMessage, deleteToken };
export default app;